import * as yup from "yup";

export const singinValidationSchema = yup
  .object({
    email: yup.string().email().required("Email is required"),
    password: yup
      .string()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*-])(?=.{8,})/,
        "Please enter a valid password." //FLMVP-2628 made changes to error messages
      )
      .max(30),
  })
  .required();

export const singupValidationSchema = yup
  .object({
    first_name: yup.string().required("first Name is required"),
    last_name: yup.string().required("Last Name is required"),
    email: yup.string().email().required("Email is required"),
    password: yup
      .string()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*-])(?=.{8,})/,
        // "The password has to be secure. Be sure it contains at least\n 1 number, 1 letter, 1 capital letter, 1 symbol \n between 8 and 30 characters length \n doesn't contain whitespaces"
        "Password must contain 8-30 characters, include at least 1 number, 1 uppercase letter, 1 symbol, and no whitespaces."
      )
      .max(30),
    confirmPassword: yup.string().oneOf([yup.ref("password"), null], "Passwords must match"),
    isValid: yup.boolean().oneOf([true], "You must agree to the terms and conditions"),
  })
  .required();

export const changePasswordValidationSchema = yup
  .object({
    oldPassword: yup
      .string()
      .required("Old Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*-])(?=.{8,})/,
        "Password must contain at least:\n 1 number, 1 upper case letter, 1 symbol, \n is between 8 - 30 characters length \n and does not contain white spaces."
      )
      .max(30),
    newPassword: yup
      .string()
      .required("New Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*-])(?=.{8,})/,
        "Password must contain at least:\n 1 number, 1 upper case letter, 1 symbol, \n is between 8 - 30 characters length \n and does not contain white spaces."
      )
      .max(30),
    confirmNewPassword: yup.string().oneOf([yup.ref("newPassword"), null], "Passwords must match"),
  })
  .required();

export const emailValidation = (email) => {
  let error;
  if (!email) {
    error = "Email required";
  } else if (!/\S+@\S+\.\S+/.test(email)) {
    error = "Email address is invalid";
  }

  return error;
};

export const verifyEmail = yup
  .object({
    email: yup.string().email().required("Email is required"),
  })
  .required();

export const resetPasswordValidations = (values) => {
  let errors = { empty: true };

  if (!values?.code) {
    errors.code = "Please enter otp code";
  } else if (values?.code.length !== 6) {
    errors.code = "Please enter a valid otp code";
  }

  if (!values?.password) {
    errors.password = "Password is required";
  } else if (!/^(?=.*\d)(?=.*[!@#$%^&*-])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(values?.password)) {
    errors.password =
      "Password must contain 8-30 characters, include at least 1 number, 1 uppercase letter, 1 symbol, and no whitespaces.";
  }

  if (!values?.confirmPassword) {
    errors.confirmPassword = "Confirm password is required";
  } else if (values?.confirmPassword !== values?.password) {
    errors.confirmPassword = "Passwords do not match";
  }

  return errors;
};

export const userInfoValidations = (values) => {
  let errors = {};

  if (!values?.firstName) {
    errors.firstName = "Please enter first name";
  } else if (values?.firstName.length < 3) {
    errors.firstName = "Please enter a valid first name";
  }

  if (!values?.lastName) {
    errors.lastName = "Please enter last name";
  } else if (values?.lastName.length < 3) {
    errors.lastName = "Please enter a valid last name";
  }

  if (!values?.email) {
    errors.email = "Please enter email";
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = "Email address is invalid";
  }

  // if (!values?.address1) {
  //   errors.address1 = "Please enter address";
  // } else if (values?.address1.length < 3) {
  //   errors.address1 = "Please enter a valid address";
  // }

  // if (!values?.state) {
  //   errors.state = "Please enter two letter state name";
  // }
  // if (!values?.city) {
  //   errors.city = "Please enter city";
  // } else if (values?.city.length < 3) {
  //   errors.city = "Please enter a valid city";
  // }
  // if (!values?.postalCode) {
  //   errors.postalCode = "Please enter postal code";
  // } else if (values?.postalCode.length !== 5) {
  //   errors.postalCode = "Please enter a valid postal code";
  // }

  // if (!values?.date_of_birth) {
  //   errors.date_of_birth = "Please enter date of birth";
  // } else if (!underAgeValidate(moment(values?.date_of_birth).format("YYYY-MM-DD"))) {
  //   errors.date_of_birth = "Please enter a valid date of birth";
  // }
  // if (!values?.ssn) {
  //   errors.ssn = "Please enter social security number";
  // } else if (values?.ssn.length !== 9) {
  //   errors.ssn = "Please enter 4 digit valid social security number";
  // }

  return errors;
};

// function underAgeValidate(birthday) {
//   // it will accept two types of format yyyy-mm-dd and yyyy/mm/dd
//   var optimizedBirthday = birthday.replace(/-/g, "/");

//   //set date based on birthday at 01:00:00 hours GMT+0100 (CET)
//   var myBirthday = new Date(optimizedBirthday);

//   // set current day on 01:00:00 hours GMT+0100 (CET)
//   var currentDate = new Date().toJSON().slice(0, 10) + " 01:00:00";

//   // calculate age comparing current date and borthday
//   var myAge = ~~((Date.now(currentDate) - myBirthday) / 31557600000);
//   if (myAge < 18) {
//     return false;
//   } else {
//     return true;
//   }
// }
